import moment from 'moment';

export const fmt = (value: string | number | null | undefined, digits = 2): string => {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  if (Number.isNaN(number)) return String(value);
  return number.toLocaleString('ru-RU', { minimumFractionDigits: digits, maximumFractionDigits: digits });
};

export const fmtInt = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : value.toLocaleString('ru-RU');

export const monthStart = () => moment().startOf('month').format('YYYY-MM-DD');
export const today = () => moment().format('YYYY-MM-DD');
export const previousMonth = () => ({
  from: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
  to: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
});

export const toneOf = (value: string | number): 'ok' | 'bad' | '' => {
  const number = Number(value);
  if (number > 0) return 'ok';
  if (number < 0) return 'bad';
  return '';
};

// Ошибка DRF: {"amount": ["..."]} или {"amount": "..."} или {"detail": "..."}
export const errorText = (error: unknown): string => {
  const data = (error as { data?: unknown })?.data;
  if (!data || typeof data !== 'object') return 'Не удалось выполнить запрос.';
  return Object.values(data as Record<string, unknown>)
    .map((value) => (Array.isArray(value) ? value.join(' ') : String(value)))
    .join(' ');
};

export const SETTLEMENT_STATUS: Record<string, string> = {
  CREATED: 'Создан',
  IN_PROGRESS: 'В работе',
  COMPLETED: 'Завершён',
  REJECTED: 'Отклонён',
};

export const DIRECTION: Record<string, string> = {
  M2P: 'Мерчант → Площадка',
  P2M: 'Площадка → Мерчант',
};
